import React from 'react'
import { Link } from 'react-router-dom'
// import { _isloadinginitial } from '../RecoilState';
// import { useRecoilState } from 'recoil';
import YanchaWonderGame from '../pages/YanchaWonderGame';

const Footer = () => {
    // const [isloading, setisLoading] = useRecoilState(_isloadinginitial)

    return (
        <>
            <div className='footer'>
                <div className='flex flex-row w-full'>

                    {/* home */}
                    <div className='w-1/6'>
                        <Link to="/">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/home-icon.png')} width={32} alt="home" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>home</p>
                            </div>
                        </Link>
                    </div>

                    {/* programs */}
                    <div className='w-1/6'>
                        <Link to="/programs">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/programs-icon.png')} width={32} alt="programs" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>programs</p>
                            </div>
                        </Link>
                    </div>

                    {/* jido */}
                    <div className='w-1/6'>
                        <Link to="/jido">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/jdo.png')} width={47} alt="home" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>jido</p>
                            </div>
                        </Link>
                    </div>

                    {/* game */}
                    <div className='w-1/6'>
                        <Link to="/wonder-game">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/games-icon.png')} width={32} alt="8th wonder" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>8th Wonder</p>
                            </div>
                        </Link>
                    </div>

                    {/* about */}
                    <div className='w-1/6'>
                        <Link to="/about">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/info.png')} width={32} alt="about" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>about</p>
                            </div>
                        </Link>
                    </div>

                    {/* contact WA */}
                    <div className='w-1/6'>
                        <Link to="https://wa.me/9147074187?text=I'm%20interested%20in%20Yancha.Tell%20me%20more.">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/whatsapp-icon.png')} width={32} alt="contact" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>contact</p>
                            </div>
                        </Link>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Footer